const SubscriptionStatus = {
	INITIAL: 'initial', // Initial status, before first payment
	ACTIVE: 'active', // When subscription is active and valid, regardless if auto renew is on or off
	EXPIRED: 'expired', // When subscription is no longer valid, needs renew
} as const;

export function getSubscriptionStatusLabel(status: ValueOf<typeof SubscriptionStatus>) {
	switch (status) {
		case SubscriptionStatus.INITIAL:
		default:
			return 'Initial';
		case SubscriptionStatus.ACTIVE:
			return 'Active';
		case SubscriptionStatus.EXPIRED:
			return 'Expired';
	}
}

export default SubscriptionStatus;
